import { useState } from 'react'
import { MessageSquare } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useInvoiceNotes } from '@/hooks/useInvoiceNotes'

import { NotesPanel } from './NotesPanel'

interface NotesDialogButtonProps {
  invoiceId: string
}

export function NotesDialogButton({ invoiceId }: NotesDialogButtonProps) {
  const [open, setOpen] = useState(false)
  const { data: notes } = useInvoiceNotes(invoiceId)
  const count = notes?.length ?? 0

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="gap-2"
      >
        <MessageSquare className="w-4 h-4" />
        Notes
        {count > 0 && (
          <span className="ml-1 text-[10px] font-semibold text-neutral-700 bg-neutral-200 rounded px-1.5 py-0.5">
            {count}
          </span>
        )}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg p-0">
          <DialogHeader className="px-4 pt-4 pb-0">
            <DialogTitle>Notes</DialogTitle>
          </DialogHeader>
          <NotesPanel invoiceId={invoiceId} hideHeader />
        </DialogContent>
      </Dialog>
    </>
  )
}
